import { WidgetPresence } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import type { Action, Dispatch } from 'redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { widgetActions } from 'components/widget/widget.actions';

import { getMessengerWidgetTokenAndUrl } from './config';

export interface Props {
  profile: User;
  setPresence: (presence: WidgetPresence) => void;
}

class DixaMessenger extends PureComponent<Props> {
  componentDidMount() {
    const { messengerToken, loaderUrl } = getMessengerWidgetTokenAndUrl();

    this.injectDixaMessenger(loaderUrl);
    this.initializeDixaMessenger(messengerToken);

    // handleWidgetPresenceChange must be according to the
    // dixa messenger informing us of the events happening
    // in it. But for now since dixa messenger is still
    // not developed enough, we do it by hand. This is a "hack"
    this.handleWidgetPresenceChange({
      show_widget: true,
      show_contact_form: true,
    });
  }

  handleWidgetPresenceChange(presence: WidgetPresence): void {
    this.props.setPresence(presence);
  }

  initializeDixaMessenger(messengerToken: string): void {
    window?._dixa_?.invoke('init', {
      messengerToken,
      hideToggler: true,
      showWidgetCloseButton: true,
      userIdentity: this.getAuthenticateData(),
    });
  }

  getAuthenticateData() {
    const { profile } = this.props;
    return {
      type: 'claim',
      name: profile.name,
      email: profile.email,
    };
  }

  injectDixaMessenger(loaderUrl: string): void {
    if (window._dixa_) return;

    // create a stub for the messenger to capture the commands
    // before the actual widget is loaded, so that they can be
    // executed afterwards.
    window._dixa_ = {
      pendingCalls: [],
      invoke: function (m, a) {
        // @ts-expect-error we are assigning value to `window._dixa_` property
        window._dixa_.pendingCalls = window._dixa_.pendingCalls || [];
        window._dixa_?.pendingCalls.push([m, a]);
      },
      addListener: function (event, listener) {
        // @ts-expect-error we are assigning value to `window._dixa_` property
        window._dixa_.pendingAddListenerCalls =
          window._dixa_?.pendingAddListenerCalls || [];
        window._dixa_?.pendingAddListenerCalls.push([event, listener]);
      },
    };

    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.setAttribute('charset', 'utf-8');
    scriptElement.async = true;
    scriptElement.src = loaderUrl;

    const firstScriptElement = document.getElementsByTagName('script')[0];

    if (firstScriptElement.parentNode) {
      firstScriptElement.parentNode?.insertBefore(
        scriptElement,
        firstScriptElement,
      );
    } else {
      console.error('Failed to insert the dixa messenger to the document');
    }
  }

  render() {
    return null;
  }
}

type WidgetStateProps = Pick<Props, 'profile'>;

const mapStateToProps = (state: RootReducerStateT): WidgetStateProps => {
  return {
    profile: state.settings.profile.profile,
  };
};

type WidgetDispatchProps = Pick<Props, 'setPresence'>;

const mapDispatchToProps = (
  dispatch: Dispatch<Action>,
): WidgetDispatchProps => {
  return {
    setPresence(presence) {
      dispatch(widgetActions.setPresence({ presence }));
    },
  };
};

export const DixaMessengerWidget = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DixaMessenger);
